import checkIfStringEmpty from '_/common/utils/validation/checkIfStringEmpty';
import { INameEntity } from '_/types/common.types';
import * as Yup from 'yup';

export const checkIfNameExists = (nameEntities: INameEntity[], newName = ''): boolean =>
  !!nameEntities.find(({ name }) => name.toLowerCase() === newName.toLowerCase());

const nameValidator = (nameEntities: INameEntity[], entityName: string): Yup.AnySchema =>
  Yup.string()
    .test('isRequired', (value, { createError }) =>
      checkIfStringEmpty(value) ? createError({ message: 'Name is required.' }) : true,
    )
    .test('isNameUnique', (value, { createError }) =>
      checkIfNameExists(nameEntities, value)
        ? createError({ message: `${entityName} with name "${value}" already exists.` })
        : true,
    );

export default nameValidator;
